var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _vm.showSupplierInfo
      ? _c(
          "div",
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.showList } },
              [_vm._v("Back To List")]
            ),
            _c("proposal-pane", {
              staticStyle: { "margin-top": "10px" },
              attrs: { round: _vm.roundData, ssr: _vm.ssr },
            }),
          ],
          1
        )
      : _vm._e(),
    !_vm.showSupplierInfo
      ? _c(
          "div",
          [
            _vm._l(_vm.rounds, function (round) {
              return _c(
                "div",
                [
                  _c("div", [
                    _vm._v(
                      "Proposal " +
                        _vm._s(_vm._f("romanNum")(round.roundNumber))
                    ),
                  ]),
                  _c(
                    "el-table",
                    {
                      ref: "supplierList",
                      refInFor: true,
                      staticStyle: { "margin-top": "15px" },
                      attrs: {
                        data: round.ssrRoundSuppliers,
                        border: "",
                        "highlight-current-row": "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "supplierCode",
                          label: _vm.$t("ssrManage.invitationCode"),
                          width: "128",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "supplierName",
                          label: _vm.$t("ssrManage.supplierName"),
                          "min-width": "200",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "proposal",
                          label: _vm.$t("ssrManage.proposalDoc"),
                          width: "100",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("file-list", {
                                    attrs: { files: scope.row.proposalDocs },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "submitDate",
                          label: _vm.$t("ssrManage.submitDate"),
                          width: "150",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("dateFormatFilter")(
                                          scope.row.submitDate,
                                          "YYYY-MM-DD"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("ssrManage.downloadAttac"),
                          width: "200",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("file-list", {
                                    attrs: {
                                      "can-edit": false,
                                      files: scope.row.otherFormat,
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "Detail", width: "100" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-link",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showDetail(
                                            round,
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Get Details")]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _c(
                        "template",
                        { slot: "append" },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                {
                                  staticStyle: {
                                    "line-height": "32px",
                                    "text-align": "right",
                                    "padding-right": "1em",
                                  },
                                  attrs: { span: "2" },
                                },
                                [_c("span", [_vm._v("Remark")])]
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: "22" } },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: round.remarks,
                                      callback: function ($$v) {
                                        _vm.$set(round, "remarks", $$v)
                                      },
                                      expression: "round.remarks",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              )
            }),
            _c(
              "el-row",
              { staticStyle: { "margin-top": "2em" } },
              [
                _c(
                  "el-col",
                  { attrs: { offset: "11", span: "2" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.saveRoundMark },
                      },
                      [_vm._v("Save")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }